export default __webpack_public_path__ + "static/media/profile.2b54e2a9.png";